export default "__VITE_ASSET__CyYRxucM__"